import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Tabs, Tab, Alert, Button } from 'react-bootstrap';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

import OrdersMap from '../components/maps/OrdersMap';
import OrdersList from '../components/orders/OperatorOrdersListComponent';
import { OrdersListActionBar } from '../components/orders/OrdersListActionBarComponent';
import DriverListComponent from '../components/driverList/DriverListComponent';
import * as actions from '../actions/dashboardPageActions';
import * as appActions from '../actions/appActions';
import * as fleetActions from '../actions/fleetOwnerActions';
import * as adminActions from '../actions/adminActions';
import * as onDemandActions from '../actions/onDemandActions';

import { gettext } from '../i18n/service';

import getPickUpPointsAndRecipientsFromOrders from '../businessLogic/getRecipientsAndPointsFromOrders.js';
import { convertArrToObj } from '../businessLogic/convertArrToObj';
import { getTeamsIds } from '../businessLogic/teamHelper';

import { fitToOrders, fitToDriver } from '../utils/fitToBounds';

export class FleetOwnerContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      draggingOrder: undefined,
      showOrderOption: {
        assigned: true,
        unassigned: true,
        deliveryPoint: true,
        pickupPoint: true,
        waitingForPickup: true,
        onWayToDelivery: true,
        pickedUp: true,
        partlyPickedUp: true,
        waitingForReturn: true,
      }
    };
    this.setOfLocationsToShowPopup = new Set();
    this.setOfDriverLocationIdsToShowPopup = new Set();
    this.ordersSelectedOnTable = [];
    this.selectedDriver = undefined;
    this.selectedTeam = undefined;
    this.driverShowType = 'all';
    this.upCategoryIndex = false;
    this.showModal = false;
    this.operatorsId = [];
    this.dispatchersId = [];
    this.fleetsId = [];

    _.bindAll(this, ['createNewOrder', 'getPickUpPoints', 'getDriversFromUsers', 'getDispatchersFromUsers', 'getOperatorsFromUsers', 'updateUpCategoryIndex',
      'prepareUserList', 'unassignSelectedOrders', 'unassignOrder', 'changeOrderListViewMode', 'clearSelectedOrders', 'toggleCategoryModal', 'changeCategoryState',
      'handleOrderSelectChange', 'passSelectedDriver', 'passSelectedTeam', 'driverShowFilterUpdate', 'getSelectedDriver', 'dropOrdersToDriver', 'onDriverMarkerClick', 'onMarkerClick',
      'handleMarkerClose', 'handleDriverMarkerClose', 'getDispatcherPlatformsFromUsers', 'closeAllInfoWindows', 'getSelectedTeam', 'dropOrdersToTeam',
      'changeDriverListViewMode', 'onOrderDetailLinkClick', 'startDraggingOrder']);

  }
  componentWillMount() {
    this.props.onDemandActions.getAllOrdersForCompany(this.props.company.id);
  }
  componentDidMount() {
    mixpanel.people.set_once({ "Role" : "Owner", "Company": this.props.company.name, "company ID": this.props.company.id, "$created": this.props.account.createdAt });
    mixpanel.people.set({ "$name": this.props.account.name, "$email": this.props.account.email, "$phone": this.props.account.phone });
    mixpanel.identify(this.props.account.id);
    mixpanel.track("logged in");
    mixpanel.people.set({"Last Login": new Date()});
    mixpanel.people.increment("Login Count");
    //Fetch only active driver's locations
    this.props.fleetActions.getDrivers(this.props.company.id)
    // this.props.appActions.updateDriversLocations();
    // this.updateDriversInterval = setInterval(() => {
    //   this.props.fleetActions.getDrivers(this.props.company.id)
    // }, 2000);
    this.props.fleetActions.getFleetOrders(this.props.company.id);
    this.props.appActions.getTeams(this.props.company.id);
  }
  componentWillUnmount() {
    clearInterval(this.updateDriversInterval);
  }
  updateUpCategoryIndex(upbool) {
    this.upCategoryIndex = upbool;
    this.forceUpdate();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.company.id !== this.props.company.id) {

    }
    if (nextProps.orders !== this.props.orders && !this.props.areOrdersLoaded) {
      let stuff = getPickUpPointsAndRecipientsFromOrders(nextProps.orders);
      this.props.appActions.savePickupPoints(stuff.pickUpPoints);
      this.props.appActions.saveRecipients(stuff.recipients);
    }
  }

  changeCategoryState() {
    // this.showOrderOption[category] = value
    // this.forceUpdate();
    this.setState({});
  }

  closeAllInfoWindows() {
    this.props.appActions.removeNearestDrivers();
    this.setOfLocationsToShowPopup = new Set();
    this.setOfDriverLocationIdsToShowPopup = new Set();
    this.forceUpdate();
  }

  onMarkerClick(stringifiedLocation) {
    //showing only one popup on map
    this.setOfLocationsToShowPopup.clear();
    this.setOfLocationsToShowPopup.add(stringifiedLocation);
    localStorage.setItem('curposlng', JSON.parse(stringifiedLocation).lng);
    localStorage.setItem('curposlat', JSON.parse(stringifiedLocation).lat);
    this.forceUpdate();
  }

  handleMarkerClose(stringifiedLocation) {
    this.setOfLocationsToShowPopup.delete(stringifiedLocation);
    this.forceUpdate();
  }

  handleDriverMarkerClose(driverLocationId) {
    this.selectedDriverId = undefined;
    this.setOfDriverLocationIdsToShowPopup.delete(driverLocationId);
    this.forceUpdate();
  }

  toggleCategoryModal() {
    this.showModal = this.showModal ? false : true;
    this.forceUpdate();
  }
  unassignSelectedOrders() {
    this.props.appActions.startSpinner();
    _.map(this.ordersSelectedOnTable, (order) => {
      if (order.orderStatus !== 'assigned' && order.orderStatus !== 'waitingForPickup') {
        return this.props.showMessage({
          message: gettext('CAN-UNASSIGN-ONLY'),
          level: 'error'
        });
      }
      this.unassignOrder(order.id)
    });
    this.props.appActions.endSpinner();
    this.ordersSelectedOnTable = [];
    this.forceUpdate();
  }

  unassignOrder(id) {
    this.props.appActions.startSpinner();
    this.props.actions.unassignOrder(id);
  }

  passSelectedDriver(driver) {
    if (driver !== this.selectedDriver) {
      this.selectedDriver = driver;
      this.forceUpdate();
    }
    this.closeAllInfoWindows();
    if (driver) {
      var bounds = new google.maps.LatLngBounds();
      const driverOrders = _.filter(this.props.orders, (order) => { return order.driverId === driver.id})
      if (driverOrders.length > 0) {
        fitToOrders(bounds, driverOrders, this._map, this.props.recipients, this.props.pickUpPoints);
      } else {
        const driversLocations = _.filter(this.props.driversLocations, { driverId: driver.id });
        if (driversLocations.length === 0) console.warn('Driver have no location ' + driver.id);
        fitToDriver(bounds, driversLocations, this._map)
      }
      
    }

    // this.forceUpdate();
  }

  passSelectedTeam(team) {
    if (team !== this.selectedTeam) {
      this.selectedTeam = team;
      this.forceUpdate();
    }
  }
  driverShowFilterUpdate(val) {
    if (val !== this.driverShowType) {
      this.driverShowType = val;
      this.forceUpdate();
    }
  }
  getSelectedDriver() {
    return this.selectedDriver;
  }

  getSelectedTeam() {
    return this.selectedTeam;
  }

  changeOrderListViewMode(viewMode) {
    this.ordersSelectedOnTable = [];
    this.props.actions.changeOrderListViewMode(viewMode);
    this.forceUpdate();
  }

  changeDriverListViewMode(viewMode) {
    this.selectedDriver = undefined;
    this.selectedTeam = undefined;
    this.props.actions.changeDriverListViewMode(viewMode);
    this.forceUpdate();
  }

  createNewOrder(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.appActions.removeOrderForUpdate();
    this.props.router.push('/createNewOrder');
  }

  getPickUpPoints(users) {
    let pickUpPoints = [];
    _.map(users, (user) => {
      _.map(user.dispatchers, (dispatcher) => {
        _.map(dispatcher.pickUpPoints, (pickUpPoint) => {
          pickUpPoints.push(pickUpPoint);
        });
      });
    });
    this.props.fleetActions.addPickupPointsToStore(pickUpPoints);
  }

  getDriversFromUsers(driversFromState) {
    let drivers = [];
    _.map(driversFromState, (driverFrSt) => {
      drivers.push(driverFrSt.id);
    });

    return drivers;
  }

  getActiveDriversIds = (driversFromState) => {
    let drivers = [];
    _.map(driversFromState, (driverFrSt) => {
      if (driverFrSt.driverStatus === 'active')
        drivers.push(`"${driverFrSt.id}"`);
    });

    return drivers;
  }

  getDispatcherPlatformsFromUsers(teams) {
    let platforms = [];
    _.map(teams, (team) => {
      _.map(team.dispatcherPlatforms, (platform) => {
        platform.role = 'dispatcherPlatform';
        ////it's team id
        platform.teamId = team.id;
        platforms.push(platform);
      });
    });

    return platforms;
  }

  getDispatchersFromUsers(teams) {
    let dispatchers = [];
    _.map(teams, (team) => {
      _.map(team.dispatchers, (dispatcher) => {
        dispatcher.role = 'dispatcher';
        ////it's team id
        dispatcher.teamId = team.id;
        dispatchers.push(dispatcher);
        this.dispatchersId.push(dispatcher.id);
      });
    });

    return dispatchers;
  }

  getOperatorsFromUsers(teams) {
    let operators = [];
    _.map(teams, (team) => {
      _.map(team.operators, (operator) => {
        operator.role = 'operator';
        ////it's team id
        operator.teamId = team.id;
        operators.push(operator);
        this.operatorsId.push(operator.id);

      });
    });

    return operators;
  }

  getOrdersMap = (map) => {
    this._map = map;
    this.setState({});
  }

  handleOrderSelectChange(order, e) {
    e.stopPropagation();
    const isSelected = this.ordersSelectedOnTable.includes(order);
    if (!isSelected) {
      this.ordersSelectedOnTable.push(order);
    } else {
      _.pull(this.ordersSelectedOnTable, order);
    }
    this.closeAllInfoWindows();
    var bounds = new google.maps.LatLngBounds();
    fitToOrders(bounds, this.ordersSelectedOnTable, this._map, this.props.recipients, this.props.pickUpPoints)
    this.forceUpdate();
    return true;
  }

  onDriverMarkerClick(driverLocationId, driverId) {
    this.selectedDriverId = driverId;
    this.setOfDriverLocationIdsToShowPopup.clear();
    this.setOfDriverLocationIdsToShowPopup.add(driverLocationId);
    this.forceUpdate();
  }

  prepareUserList(users) {
    let drivers = this.getDriversFromUsers(users);
    let operators = this.getOperatorsFromUsers(users);
    let dispatchers = this.getDispatchersFromUsers(users);
    let platforms = this.getDispatcherPlatformsFromUsers(users);
    this.props.fleetActions.addUsersToStore(drivers.concat(operators, dispatchers, platforms));
  }

  clearSelectedOrders() {
    this.ordersSelectedOnTable = [];
    this.ordersSelectedOnMap = [];
    this.forceUpdate();
  }

  dropOrdersToDriver(driverId) {
    let driver = _.find(this.props.drivers, { id: driverId });
    if (driver && driver.blocked)
      return this.props.showMessage({
        message: gettext('DRIVER-IS-BLOCKED'),
        level: 'error'
      });

    if (driver && this.props.company.cashOnDeliveryCap > 0 && driver.cashOnDelivery >= this.props.company.cashOnDeliveryCap) {
      return this.props.showMessage({
        message: gettext('DRIVER-CANT-RECIEVE-MORE-ORDERS'),
        level: 'error'
      });
    }

    if (this.state.draggingOrder
      && this.state.draggingOrder.id
      && this.ordersSelectedOnTable.length === 0
      && this.state.draggingOrder.orderStatus === 'new'
      && driver.vehicleType >= this.state.draggingOrder.vehicleType) {
      this.props.actions.assignOnDriver(driverId, this.state.draggingOrder.id, localStorage.getItem('userType'));
    }
    else if (this.ordersSelectedOnTable.length === 0 && driver && this.state.draggingOrder && driver.vehicleType <= this.state.draggingOrder.vehicleType) {
      this.props.appActions.endSpinner();
      return this.props.showMessage({
        message: gettext('DRIVER-HAVE-ANOTHER-VEHICLE-TYPE'),
        level: 'error'
      });
    }

    _.map(this.ordersSelectedOnTable, (order) => {
      if (driver.vehicleType >= order.vehicleType) {
        if (order.orderStatus === 'new')
          this.props.actions.assignOnDriver(driverId, order.id, localStorage.getItem('userType'));
      }
      else if (driver && driver.vehicleType <= order.vehicleType) {
        this.props.appActions.endSpinner();
        return this.props.showMessage({
          message: gettext('DRIVER-HAVE-ANOTHER-VEHICLE-TYPE'),
          level: 'error'
        });
      }
    });

    this.props.appActions.startSpinner();
    this.props.actions.assignOnDriver(driverId, _.map(this.ordersSelectedOnTable, order => order.id), localStorage.getItem('userType'));
    this.selectedDriver = undefined;
    this.clearSelectedOrders();
  }

  dropOrdersToTeam(teamId) {
    this.props.appActions.startSpinner();
    _.map(this.ordersSelectedOnTable, (order) => {
      this.props.actions.assignOnTeam({ orderId: order.id, teamsIds: [teamId] });
    });
    this.selectedTeam = undefined;
    this.clearSelectedOrders();
  }

  onOrderDetailLinkClick(order, e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    return this.props.router.push(`/orderDetails/${order.id}`);
  }

  startDraggingOrder(order) {
    this.setState({ draggingOrder: order });
  }
  setNearestCenter = (e) => {
    this.nearestCenter = JSON.parse(e);
    this.forceUpdate;
  }

  render() {
    let { showOrderOption } = this.props;
    const ordersForTable = _(this.props.orders)
      .filter((order) => order.orderStatus === 'new')
      .sortBy('createdAt', 'expectedPickUpTime').value();

    let ordersForMap = this.props.orders
    if (this.ordersSelectedOnTable && this.ordersSelectedOnTable.length > 0)
      ordersForMap = this.ordersSelectedOnTable;
    else if (this.selectedDriver)
      ordersForMap = _.filter(ordersForMap, (order) => { return order.driverId === this.selectedDriver.id });

    ordersForMap = _.filter(ordersForMap, (order) => {
      return order.orderStatus === (showOrderOption.unassigned == true ? 'new' : 'demo')
        || order.orderStatus === (showOrderOption.assigned == true ? 'assigned' : 'demo')
        || order.orderStatus === (showOrderOption.onWayToDelivery == true ? 'onWayToDelivery' : 'demo')
        || order.orderStatus === (showOrderOption.waitingForPickup == true ? 'waitingForPickup' : 'demo')
        || order.orderStatus === (showOrderOption.partlyPickedUp == true ? 'partlyPickedUp' : 'demo')
        || order.orderStatus === (showOrderOption.pickedUp == true ? 'pickedUp' : 'demo');
    });

    const ordersForInProgressTable = _(this.props.orders)
      .filter((order) => order.orderStatus === 'assigned'
        || order.orderStatus === 'onWayToDelivery'
        || order.orderStatus === 'waitingForPickup'
        || order.orderStatus === 'pickedUp'
        || order.orderStatus === 'partlyPickedUp'
        || order.orderStatus === 'waitingForReturn')
      .sortBy('createdAt', 'expectedPickUpTime').value();


    const ordersForHistoryTable = _(this.props.orders)
      .filter((order) => order.orderStatus === 'canceled' || order.orderStatus === 'delivered' || order.orderStatus === 'returned')
      .sortBy('processedAt').value();

    let lowerProcessedAtTime = undefined;
    _.map(ordersForHistoryTable, (order, i) => {
      if (i === 1)
        lowerProcessedAtTime = order.processedAt;

      if (order.processedAt < lowerProcessedAtTime)
        lowerProcessedAtTime = order.processedAt;
    });

    const historyPageCount = Math.round(ordersForHistoryTable.length / 15);

    let table;
    switch (this.props.orderListViewMode) {
      case 'orders':
        table =
          (
            <div>
              <div className="driver-list-pad">
                <DriverListComponent
                  updateUpCategoryIndex={this.updateUpCategoryIndex}
                  dispatchers={this.props.users.filter((user) => user.role === 'dispatcher')}
                  recipients={this.props.recipients}
                  ordersSelectedOnTable={this.ordersSelectedOnTable}
                  assignOnDriver={this.props.actions.assignOnDriver}
                  startSpinner={this.props.appActions.startSpinner}
                  clearSelectedOrders={this.clearSelectedOrders}
                  passSelectedDriver={this.passSelectedDriver}
                  passSelectedTeam={this.passSelectedTeam}
                  selectedDriver={this.selectedDriver}
                  getSelectedDriver={this.getSelectedDriver}
                  getSelectedTeam={this.getSelectedTeam}
                  dropOrdersToDriver={this.dropOrdersToDriver}
                  dropOrdersToTeam={this.dropOrdersToTeam}
                  startSpinner={this.props.appActions.startSpinner}
                  showMessage={this.props.showMessage}
                  driverShowFilterUpdate={this.driverShowFilterUpdate}
                  driverListViewMode={this.props.driverListViewMode}
                  driverShowType={this.driverShowType}
                  changeDriverListViewMode={this.props.actions.changeDriverListViewMode}
                  renderModalForDetails={this.props.renderModalForDetails} />
              </div>
              <OrdersList
                orderListViewMode={this.props.orderListViewMode}
                orders={ordersForTable}
                users={this.props.users}
                handleOrderSelectChange={this.handleOrderSelectChange}
                showOrderDetails={this.onOrderDetailLinkClick}
                selectedOrders={this.ordersSelectedOnTable}
                vehicles={this.props.vehicles}
                recipients={this.props.recipients}
                cancelOrder={this.cancelOrder}
                showMessage={this.props.showMessage}
                loaded={this.props.loaded}
                orderListPageNumber={this.props.orderListPageNumber}
                saveCurrentPageOrderList={this.saveCurrentPageOrderList}
                clearSelectedOrders={this.clearSelectedOrders}
                company={this.props.company}
                router={this.props.router}
                appActions={this.props.appActions}
                cancelOrder={this.props.actions.cancelOrder}
                pickUpPoints={this.props.pickUpPoints}
                renderModalForDetails={this.props.renderModalForDetails}
                startDraggingOrder={this.startDraggingOrder} />
            </div>
          );
        break;
      case 'assignedOrders':
        table =
          (<OrdersList
            orderListViewMode={this.props.orderListViewMode}
            orders={ordersForInProgressTable}
            users={this.props.users}
            vehicles={this.props.vehicles}
            showMessage={this.props.showMessage}
            selectedOrders={this.ordersSelectedOnTable}
            clearSelectedOrders={this.clearSelectedOrders}
            handleOrderSelectChange={this.handleOrderSelectChange}
            company={this.props.company}
            router={this.props.router}
            appActions={this.props.appActions}
            pickUpPoints={this.props.pickUpPoints}
            renderModalForDetails={this.props.renderModalForDetails} />);
        break;
    }
    return (
      <div>
        {this.props.account.isBlocked ?
          <Alert bsStyle="danger" className="pay_div" onDismiss={this.handleAlertDismiss}>
            <h4>Company is blocked!</h4>
            <Button onClick={() => this.props.router.push('/pay')}>{gettext('PAY')}</Button>
          </Alert> : ''}
        <OrdersMap
          defaultZoom={10}
          users={this.props.users}
          getOrdersMap={this.getOrdersMap}
          updateUpCategoryIndex={this.updateUpCategoryIndex}
          upCategoryIndex={this.upCategoryIndex}
          nearestCenter={this.nearestCenter}
          setNearestCenter={this.setNearestCenter}
          showOrderOption={showOrderOption}
          changeCategoryState={this.changeCategoryState}
          nearestDrivers={this.props.nearestDrivers}
          orders={ordersForMap}
          allPickUpPoints={this.props.pickUpPoints}
          toggleCategoryModal={this.toggleCategoryModal}
          showModal={this.showModal}
          setOfLocationsToShowPopup={this.setOfLocationsToShowPopup}
          setOfDriverLocationIdsToShowPopup={this.setOfDriverLocationIdsToShowPopup}
          company={this.props.company}
          recipients={this.props.recipients}
          onDriverMarkerClick={this.onDriverMarkerClick}
          onMarkerClick={this.onMarkerClick}
          driverShowType={this.driverShowType}
          handleMarkerClose={this.handleMarkerClose}
          getNearestDrivers={this.props.appActions.getNearestDrivers}
          handleDriverMarkerClose={this.handleDriverMarkerClose}
          closeAllInfoWindows={this.closeAllInfoWindows}
          onOrderDetailLinkClick={this.onOrderDetailLinkClick}
          handleOrderSelectChange={this.handleOrderSelectChange}
          polygon={this.selectedTeam ? this.selectedTeam.polygon : undefined}
          selectedDriver={this.selectedDriver}
          fullSize={false}
          renderModalForDetails={this.props.renderModalForDetails}
          clearSelectedOrders={this.clearSelectedOrders}
        />

        <OrdersListActionBar
          orderListViewMode={this.props.orderListViewMode}
          changeOrderListViewMode={this.changeOrderListViewMode}
          createNewOrder={this.createNewOrder}
          unassignOrders={this.unassignSelectedOrders}
          selectedOrders={this.ordersSelectedOnTable}
          account={this.props.account} />

        <DragDropContextProvider backend={HTML5Backend}>
          {table}
        </DragDropContextProvider>
        {this.state.modal}
      </div>
    );
  }
}

FleetOwnerContainer.propTypes = {
  actions: PropTypes.object,
  appActions: PropTypes.object,
  account: PropTypes.object,
  orders: PropTypes.array,
  orderListViewMode: PropTypes.string,
  pickUpPoints: PropTypes.array,
  vehicles: PropTypes.array,
  users: PropTypes.array
};

function mapStateToProps(state) {
  return {
    account: state.appReducer.account,
    orders: state.appReducer.orders,
    orderListViewMode: state.dashboardPageReducer.orderListViewMode,
    pickUpPoints: state.appReducer.pickUpPoints,
    vehicles: state.appReducer.vehicles,
    users: state.appReducer.users,
    company: state.appReducer.company,
    recipients: state.appReducer.recipients,
    cards: state.appReducer.cards,
    teams: state.dashboardPageReducer.teams,
    nearestDrivers: state.appReducer.nearestDrivers,
    areOrdersLoaded: state.appReducer.areOrdersLoaded,
    drivers: state.dashboardPageReducer.drivers,
    showOrderOption: state.dashboardPageReducer.showOrderOption,
    driversLocations: state.dashboardPageReducer.driversLocations
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    appActions: bindActionCreators(appActions, dispatch),
    fleetActions: bindActionCreators(fleetActions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    onDemandActions: bindActionCreators(onDemandActions, dispatch)

  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FleetOwnerContainer);



// WEBPACK FOOTER //
// ./src/containers/FleetOwnerContainer.js